import React, { useEffect, useState } from "react";
import { Box, Typography, Container, Link, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { auth } from "../../../firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import Routes from "../../../utils/Routes";
import { CallApiWithToken, callTokenApi } from "../../../api/ApiRequest";
import Loader from "../../../components/Loader";
import Button from "../../../components/Button";
import TextBox from "../../../components/TextField";
import { getReferralCode } from "../../../utils/Utils";
import Logo from "../../../assets/images/Logo.png";
import Mail from "../../../assets/icons/Mail.png";
import Lock from "../../../assets/icons/Lock.png";
import { makeStyles } from "@mui/styles";
import Alert from "../../../components/Alert";
import { Unlock } from "react-feather";

function LogInScreen({ className }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState({
    open: false,
    message: "",
    severity: "error",
  });

  useEffect(() => {
    setEmail("");
  }, []);

  const signInHandler = async () => {
    if (!email && !password) {
      setAlert({
        open: true,
        message: "Please enter both email and password.",
        severity: "warning",
      });
      return;
    }
    if (!email) {
      setAlert({
        open: true,
        message: "Please enter email.",
        severity: "warning",
      });
      return;
    }
    if (!password) {
      setAlert({
        open: true,
        message: "Please enter password.",
        severity: "warning",
      });
      return;
    }

    try {
      setIsLoading(true);
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email.trim(),
        password.trim()
      );
      console.log(userCredential);
      await callTokenApi();
      if (userCredential) {
        localStorage.setItem("Token", userCredential?.user.uid);
        localStorage.setItem(
          "ReferralCode",
          getReferralCode(userCredential?.user.displayName)
        );
        navigate("/" + Routes.Home);
      }

      setEmail("");
      setPassword("");
    } catch (error) {
      setAlert({ open: true, message: error.message, severity: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container className={className} maxWidth="sm">
      <Box className="container">
        <Box className="headingContainer">
          <img src={Logo} alt="Logo" className="logo" />
          <Typography variant="h4" className="headingText">
            Log In
          </Typography>
        </Box>

        <Box className="form">
          <TextBox
            placeholder="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            icon={Mail}
          />
          <TextBox
            placeholder="Password"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            icon={
              showPassword ? (
                <Unlock color={"rgba(127, 168, 135, 1)"} size={24} />
              ) : (
                Lock
              )
            }
            onIconClick={() => setShowPassword(!showPassword)}
          />
          <Box className="forgotPasswordContainer">
            <Link
              href={Routes.ProfileSendOTP}
              underline="hover"
              className="forgetPasswordText"
            >
              Forget Password?
            </Link>
          </Box>
          <Button
            label="Log In"
            onClick={signInHandler}
            loading={isLoading}
            disabled={isLoading}
          />
        </Box>

        <Box className="bottomContainer">
          <Typography variant="body1" className="subHeadingText">
            Don't have an account?
          </Typography>
          <Link
            href={Routes.SignUp}
            underline="hover"
            className="subHeadingText2"
          >
            Register
          </Link>
        </Box>

        {/* Privacy Policy Link */}
        <Box className="privacyContainer">
          <Link
            href="https://allislandfence.com/privacy-policy-2/"
            target="_blank"
            underline="hover"
            className="privacyText"
          >
            Privacy Policy
          </Link>
        </Box>
      </Box>
      <Alert
        open={alert.open}
        message={alert.message}
        severity={alert.severity}
        onClose={() => setAlert({ ...alert, open: false })}
      />
    </Container>
  );
}

export default styled(LogInScreen)(({}) => ({
  ".container": {
    flex: 1,
    backgroundColor: "white",
    display: "flex",
    flexDirection: "column",
  },
  ".headingContainer": {
    marginTop: "17%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  ".headingText": {
    marginTop: "3%",
    fontSize: 22,
    fontFamily: "'League Spartan', sans-serif",
    marginBottom: "5%",
  },
  ".subHeadingText": {
    fontSize: 20,
    fontFamily: "'League Spartan', sans-serif",
  },
  ".subHeadingText2": {
    fontFamily: "'League Spartan', sans-serif",
    fontSize: 20,
    color: "rgba(35, 64, 0, 1)",
  },
  ".bottomContainer": {
    marginTop: "5%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
  },
  ".logo": {
    width: 94,
    height: 94,
  },
  ".privacyContainer": {
    textAlign: "center",
    alignItems: "center",
    padding: 10,
    marginTop: 20,
  },
  ".privacyText": {
    fontSize: 16,
    fontWeight: "bold",
    color: "rgba(35, 64, 0, 1)",
  },
  ".forgetPasswordText": {
    color: "rgba(35, 64, 0, 1)",
    fontSize: 14,
    fontFamily: "LeagueSpartan-Medium",
  },
  ".forgotPasswordContainer": {
    paddingTop: "3%",
  },
}));
